import Vue from 'vue';
import App from './App.vue';
import store from './store/store';
import VueRouter from 'vue-router';
import moment from 'moment';
import axios from 'axios';
import './vendors/fontawesome';
import { router } from '@/routes';
import { NamedRoutes } from '@/routes/routes';
import EasyRefresh from 'vue-easyrefresh';
import * as Sentry from '@sentry/vue';
import VueMatomo from 'vue-matomo';
import 'leaflet/dist/leaflet.css';
import { Icon } from 'leaflet';


Sentry.init({
  Vue,
  dsn: process.env.SENTRY_DSN,
  environment: process.env.HELM_RELEASE || 'local',
  integrations: [
    new Sentry.BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
    }),
    new Sentry.Replay(),
  ],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: process.env.SENTRY_TRACING_SAMPLE_RATE,
  profilesSampleRate: process.env.SENTRY_PROFILING_SAMPLE_RATE,

  // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ['localhost', /^https:\/\/api\.welcmpass\.info/, /^https:\/\/api\.testtld4us\.de/],

  // Capture Replay for 10% of all sessions,
  // plus for 100% of sessions with an error
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

Vue.config.productionTip = false;

Vue.config.devtools = true;

Vue.config.ignoredElements = ['g:savetoandroidpay'];

moment.locale('de');
Vue.prototype.$moment = moment;

const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_API_BASEURL,
  withCredentials: true,
  // timeout: 1000,
  // headers: { header:value }
});

Vue.prototype.$axios = axiosInstance;

var socialsharing = require('vue-social-sharing');

Vue.use(socialsharing);

Vue.use(EasyRefresh);

Vue.use(VueMatomo, {
  // Konfigurieren Sie hier Ihren Matomo-Server und Ihre Website
  host: 'https://analytics.welcmpass.info/',
  siteId: parseInt(process.env.MATOMO_TRACKING_SITE_ID),
  router,
});
Vue.use(VueRouter);
Vue.prototype.$namedRoutes = NamedRoutes;

Vue.mixin({
  methods: {
    $trackEvent: function(...args: any[]) {
      // @ts-ignore
      window._paq.push(['trackEvent', ...args]);
    },
    $trackGoal: function(...args: any[]) {
      // @ts-ignore
      window._paq.push(['trackGoal', ...args]);
    },
  },
});

new Vue({
  render: h => h(App),
  store,
  router,
}).$mount('#app');

// @ts-ignore
window.mobileNavigate = async function(path: string) {
  await router.push('/' + path);
};

type D = Icon.Default & {
  _getIconUrl?: string;
};

delete (Icon.Default.prototype as D)._getIconUrl;

Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});


